import TransactionsInsights from './insights';
import TransactionDetails from './details';

export {
  TransactionDetails,
  TransactionsInsights,
};

export default TransactionsInsights;
